import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Organizations({ children }) {

  return (
    <div>
      <CustomPageHeader icon='sitemap' text='Organizations' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Organizations/index.js